import { create } from "zustand";
import axiosInstance from "../../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../../Services/baseApiUrl";

const token = localStorage.getItem("token");

export const useMonthWiseAttendanceStore = create((set) => ({
  isLoading: false,
  isUpdating: false,
  MonthWiseAttendanceData: [],
  isError: "",

  fetchMonthWiseAttendanceReport: async (queryParams) => {
    const queryString = new URLSearchParams(queryParams).toString();
    set({ isLoading: true });
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL1}AttendanceReport/GetMonthWiseAttendanceReport?${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      set({ MonthWiseAttendanceData: response.data });
    } catch (error) {
      set({ isError: error });
      console.error("Error fetching data:", error);
    } finally {
      set({ isLoading: false });
    }
  },
  updateEmployeeAttendanceStatus : async (payload) => {
    set({ isUpdating: true });
    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL1}AttendanceReport/UpdateEmployeeAttendanceStatus`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating attendance status:", error);
      throw error;
    } finally {
      set({ isUpdating: false });
    }
  }
}));
